<div>

    An unexpected error has occurred while retrieving stores.
    <br>
    <b>UserId:</b> {{userId}}
    <br>
    <b>SPL.ID:</b> {{this.splunkId}}
    <br>

    <br>
    Please contact the McLane HelpDesk.
    <br>
    Phone: <a href="" onclick="return false;">1-800-299-0379</a>
    <br>
    Email: <a href="mailto:helpdesk@mclaneco.com">helpdesk&#64;mclaneco.com</a>
    <br>

    <br>
    If you would like to retry please click OK.

</div>
